/*
  EditJSONButton.jsx
*/

// Npm.
import React, { useState } from 'react';

// Components.
import Button from '../../Button';
import Dialog from '../../Dialog';
import CodeField from '../../CodeField';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  fieldContainer: {
    margin: theme.space(2, 0),
  },
  statusText: {
    margin: theme.space(2, 0),
  },
  actionsContainer: {
    marginTop: theme.space(2),
    display: 'flex',
  },
  button: {
    marginLeft: theme.space(1),
  },
  closeButton: {
    marginRight: 'auto',
  }
}));

/**
 * Button for editing JSON of the node.
 */
export default function EditJSONButton({
  value,
  onChange,
  disabled = false,
  ...rest
}) {

  const useValue = value || {};

  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [status, setStatus] = useState('');
  const [changed, setChanged] = useState(false);

  // Handlers.

  function handleOpen() {
    setOpen(true);
    setChanged(false);
    setStatus('');
    setText(JSON.stringify(useValue, null, 2));
  }

  function handleClose() {
    if (JSON.stringify(useValue, null, 2) === text || confirm('You have unsaved changes. Continue?')) {
      setOpen(false);
    }
  }

  function handleReset() {
    setChanged(false);
    setStatus('');
    setText(JSON.stringify(useValue, null, 2));
  }

  function handleSave() {
    try {
      const obj = JSON.parse(text);
      if (Boolean(obj) && obj.constructor === Object) {
        if (onChange) {
          // NOTE: obj will be a fresh object, so no need to worry about modifying deep properties
          // that might be shared across several nodes/links.
          onChange(obj);
        }
        setText(JSON.stringify(obj, null, 2));
        setChanged(false);
        setStatus('');
      } else {
        throw new Error('JSON Must be an Object');
      }
    } catch (err) {
      setStatus(err.message);
    }
  }

  function handleChangeText(event) {
    setText(event.target.value);
    setChanged(true);
    setStatus('');
  }

  return (
    <>

      <Button
        onClick={handleOpen}
        disabled={disabled}
        {...rest}
      />

      {
        !disabled &&
        <Dialog
          open={open}
          fullWidth
          align="top"
        >
          
          <h3>Editing Raw Node</h3>

          <div className={classes.fieldContainer}>
            <CodeField
              value={text}
              onChange={handleChangeText}
              placeholder="Copy / Paste in Model"
            />
          </div>

          {
            Boolean(status) &&
            <div className="caption">
              { status }
            </div>
          }
          
          <div className={classes.actionsContainer}>
            <Button className={classes.closeButton} onClick={handleClose}>
              Close
            </Button>
            <Button className={classes.button} onClick={handleReset} disabled={!changed}>
              Reset
            </Button>
            <Button className={classes.button} onClick={handleSave} disabled={!changed}>
              Save
            </Button>
          </div>

        </Dialog>
      }
      
    </>
  );
}
